import { useMemo } from "react";
import { useSelector } from "react-redux";

import {
  selectBattery,
  selectCurrentVersion,
  selectDeviceStatus,
  selectOsVersion,
  selectProductAlias,
  selectProductId,
  selectVolume,
} from "@utils/redux-utils/selectors/productSelectors";

export function useSelectedProductSummary() {
  const productId = useSelector(selectProductId);
  const alias = useSelector(selectProductAlias);
  const battery = useSelector(selectBattery);
  const version = useSelector(selectCurrentVersion);
  const puiVersion = useSelector(selectOsVersion);
  const deviceStatus = useSelector(selectDeviceStatus);
  const volume = useSelector(selectVolume);

  return useMemo(() => {
    if (!productId) return null;

    return {
      uuid: String(productId),
      alias,
      battery,
      version,
      puiVersion,
      status: deviceStatus,
      deviceStatus,
      volume,
    };
  }, [alias, battery, deviceStatus, productId, puiVersion, version, volume]);
}
